<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
        <g fill="none" fill-rule="evenodd">
            <g fill="#FFF" stroke="#666">
                <g transform="translate(-544 -448) translate(545 449)">
                    <circle cx="6" cy="6" r="6"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'radio-uncheck'
}
</script>
